import { BehaviorSubject, Observable } from 'rxjs'
import { IsVarEmpty, isVarNotEmpty } from '../../utils/GlobalFunctions'
import { tapOnce } from './RxJS'
import { RxJSStateWithResolver } from '../Types/Types'

export class RxJSState<T, U extends (...args: unknown[]) => Promise<unknown>> implements RxJSStateWithResolver<T, U> {
    public subject: BehaviorSubject<Definable<T>>
    public observable: (...args: Parameters<U>) => Observable<Definable<T>>
    public announce: (data?: T) => void
    public resolver?: U

    public constructor(name: string, resolver?: U) {
        this.subject = new BehaviorSubject<Definable<T>>(undefined)
        this.resolver = resolver
        this.observable = (...args: Parameters<U>) =>
            IsVarEmpty(this.resolver)
                ? this.subject.asObservable()
                : this.subject.asObservable().pipe(
                      // This tapOnce function will call the resolver only on the first subscription.
                      // This means there is no need to call the resolver manually, unless you need to re-trigger it.
                      tapOnce(
                          (): Definable<Promise<unknown>> =>
                              isVarNotEmpty(args) ? this.resolver?.(...args) : this.resolver?.(),
                          name
                      )
                  )
        this.announce = (data?: T): void => this.subject.next(data)
    }

    public static newInstance<T, U extends () => Promise<unknown>>(name: string, resolver?: U): RxJSState<T, U> {
        return new RxJSState<T, U>(name, resolver)
    }
}
